export default "__VITE_PUBLIC_ASSET__09cb2615__"